<div
  [formGroup]="formGroup"
  class="pssr-form-group">
  @if (canImportSharedUsers()) {
    <div class="pssr-radio-group pssr-radio-group--vertical">
      <div class="pssr-radio-control">
        <p-radioButton
          [value]="true"
          (onClick)="onSetImporFromWhitePagesSelected()"
          class="pssr-radio"
          formControlName="canImport"
          inputId="setFromWhitePages"></p-radioButton>
        <div class="pssr-radio-label--with-description">
          <label
            class="pssr-radio-label"
            for="setFromWhitePages">
            {{ 'sharedUserForm.whitePages.title' | translate }}
          </label>
          <small class="pssr-radio-label-description">{{ 'sharedUserForm.whitePages.description' | translate }}</small>
        </div>
      </div>
      <div class="pssr-radio-control">
        <p-radioButton
          [value]="false"
          class="pssr-radio"
          formControlName="canImport"
          inputId="setCustom"></p-radioButton>
        <div class="pssr-radio-label--with-description">
          <label
            class="pssr-radio-label"
            for="setCustom">
            {{ 'sharedUserForm.customConfiguration.title' | translate }}
          </label>
          <small class="pssr-radio-label-description">
            {{ 'sharedUserForm.customConfiguration.description' | translate }}
          </small>
        </div>
      </div>
    </div>
  }
  <div class="pssr-form-control">
    <label
      [class.ng-invalid]="invalidName"
      class="pssr-form-label">
      {{ 'sharedUserForm.labels.sharedUserGroup' | translate }}
    </label>
    <input
      [readonly]="isReadOnly()"
      type="text"
      pInputText
      class="pssr-input"
      formControlName="name" />
    @if (invalidName) {
      <small class="error-message">
        {{
          'app.forms.validation.required'
            | translate: { controlName: ('sharedUserForm.labels.sharedUserGroup' | translate) }
        }}
      </small>
    }
  </div>
  @if (canImportSharedUsers() && userCanImportSharedUsers()) {
    <div class="import-shared-user__container">
      <div class="pssr-form-control">
        <label
          [class.ng-invalid]="invalidEmail"
          class="pssr-form-label">
          {{ 'sharedUserForm.labels.sharedEmail' | translate }}
        </label>
        <p-inputgroup>
          <input
            type="text"
            pInputText
            class="pssr-input"
            formControlName="email" />
          <p-inputgroup-addon>
            <p-button
              [label]="'sharedUserForm.actions.importSharedUsers' | translate"
              (onClick)="importSharedUsers()"
              severity="secondary"
              styleClass="pssr-button xs" />
          </p-inputgroup-addon>
        </p-inputgroup>
      </div>
    </div>
  } @else {
    <div class="pssr-form-control">
      <label
        [class.ng-invalid]="invalidEmail"
        class="pssr-form-label">
        {{ 'sharedUserForm.labels.sharedEmail' | translate }}
      </label>
      <input
        [readonly]="isReadOnly()"
        type="text"
        pInputText
        class="pssr-input"
        formControlName="email" />
      @if (invalidEmail) {
        <small class="error-message">
          {{
            'app.forms.validation.required'
              | translate: { controlName: ('sharedUserForm.labels.sharedEmail' | translate) }
          }}
        </small>
      }
    </div>
  }

  <div class="children__container">
    @for (childControl of childrenGroup.controls; track childControl; let childIndex = $index) {
      <ng-container formArrayName="children">
        <div class="child-user__container">
          <app-user-search-control
            [isReadOnly]="!!userCanImportSharedUsers()"
            [label]="labelUser(childIndex)"
            [formatValue]="formatUser"
            [invalid]="childControl.invalid"
            [formControlName]="childIndex"></app-user-search-control>

          @if (!userCanImportSharedUsers()) {
            <p-button
              (click)="removeChildUser(childIndex)"
              styleClass="pssr-icon-button"
              icon="pi pi-trash"
              variant="text" />
          }
        </div>
      </ng-container>
    }
  </div>

  @if (!userCanImportSharedUsers()) {
    <div class="add-childuser__button">
      <button
        [disabled]="childrenGroup.invalid"
        (click)="addUser()"
        type="button"
        class="pssr-link-action">
        <i class="pi pi-plus">&nbsp;</i>
        {{ 'sharedUserForm.actions.addChildUser' | translate }}
      </button>
    </div>
  }
</div>
